module.exports = __webpack_public_path__ + "static/media/comment-alt-dots.2c368253.svg";